import { useEffect, useState } from 'react';
import { getPricingOptions } from '@services/index';
import { useAppDispatch, useAppSelector } from './statehooks';
import { setPricingOptions } from '@store/reducers/pricingoptions';
import { PricingOptions } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/pricingoptions';

export const usePricingOptions = () => {
  const pricingOptions = useAppSelector((state) => state.pricingOptions);
  const dispatch = useAppDispatch();
  const [pricing, setPricing] = useState<PricingOptions | object>(
    pricingOptions
  );
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    if (Object.keys(pricingOptions).length === 0) {
      getPricingOptions().subscribe({
        next: (result) => {
          setPricing(result);
          setReady(true);
          dispatch(setPricingOptions({ ...result, ready: true }));
        },
        error: (err) => {
          console.log('axios err=', err);
          dispatch(setPricingOptions({}));
          setReady(true);
        },
      });
    } else {
      setReady(true);
    }
  }, []);

  return { ready: ready, pricing: pricing as PricingOptions };
};
